export const USER_LIST_LOADING = 'USER_LIST_LOADING';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const ADMIN_USER_TEAM_SUCCESS = 'ADMIN_USER_TEAM_SUCCESS';
export const ADMIN_LIST_LOADING = 'ADMIN_LIST_LOADING';
export const ADMIN_LIST_PAGE_CHANGE = 'ADMIN_LIST_PAGE_CHANGE';
export const ADMIN_LIST_SEARCH_TEXT = 'ADMIN_LIST_SEARCH_TEXT';
export const ADMIN_LIST_SEARCHING = 'ADMIN_LIST_SEARCHING';
export const ADMIN_LIST_CLEARING = 'ADMIN_LIST_CLEARING';
